import { Product } from '@inter-ikea-storageone/range';
import React from 'react';
import styled from 'styled-components';
import { getFPPImage } from 'products';
import { extractImageSource } from 'utils/imageUtils';
import { sizes } from 'ui/media';
import { isMobile } from 'utils/platform';

const Wrapper = styled.div`
  margin: 0 -${({ theme }) => (isMobile() ? 0 : theme.space.xxl)};
`;

type Props = {
  products: Product[];
};

const Image = styled.img`
  width: 100%;
  height: 10rem;
  object-fit: cover;
`;

const ImageBanner = ({ products }: Props) => {
  if (products.length === 0) {
    return null;
  }
  const fpp = getFPPImage(products[0]);
  if (fpp) {
    const { srcset, fallbackImage } = extractImageSource(fpp.sources);

    return (
      <Wrapper>
        <Image
          src={fallbackImage.src}
          alt={products[0].name}
          srcSet={srcset}
          sizes={`(max-width: ${sizes.mobile.max}px) 110px, 250px`}
        />
      </Wrapper>
    );
  }
  return null;
};

export default ImageBanner;
